import Web3 from "web3";
import nftmasterAbi from '../abis/nftmaster.json';
import { CHAIN_INFO, DEFAULT_CHAIN, IPFS_URL, SUPPORTED_CHAIN } from "./constant";
import { api } from "./api";
import localStorage from "local-storage";
import moment from "moment";


export const trimAddress = (addr = '') => {
  if(!addr) return '';
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}


export const getWeb3 = (chainId = DEFAULT_CHAIN) => {
  return new Web3(CHAIN_INFO[getCurrentChain(chainId)].rpc);
}

export const formatDateWithZone = (unixTime) => {
  try {
    let dateString = new Date(`${unixTime} UTC`).toString();
    let startIndex = dateString.indexOf("GMT");
    let modifyDate = dateString.substring(0, startIndex);
    return modifyDate;
  }
  catch (err) {
    console.log(err.message);
  }

}

export const shorterDate = (unixTime = 0) => {
  return moment(unixTime).format("MMM Do YY"); 
}


export const formatPrice = (num, decimals = 8) => {
  if (num >= 1) {
    return new Intl.NumberFormat('en-US', { maximumSignificantDigits: decimals }).format(num);
  }
  else {
    return new Intl.NumberFormat('en-US', { maximumSignificantDigits: 4 }).format(num);
  }
}


export const IPFStoURL = (ipfs = '') => {
  if (!ipfs || ipfs === '') return '';
  if (ipfs.includes('ipfs://')) {
    const cid = ipfs.replace('ipfs://', '');
    return `${IPFS_URL}${cid}`;
  }
  return IPFS_URL + ipfs;
}


export const getCurrentChain = (chain) => {
  if (chain && chain.id && SUPPORTED_CHAIN.includes(chain.id)) {
    return chain.id
  }
  return DEFAULT_CHAIN
}

export const getCreateCollectionEvent = async (tx_hash, chainId = DEFAULT_CHAIN) => {
  try {
    let web3 = getWeb3(chainId);
    let getTransactionDetails = await web3.eth.getTransactionReceipt(tx_hash);
    var nftContract = new web3.eth.Contract(nftmasterAbi, CHAIN_INFO[getCurrentChain(chainId)].nft_master);
    var event = await nftContract.getPastEvents('CreatedCollection', { fromBlock: getTransactionDetails.blockNumber, toBlock: getTransactionDetails.blockNumber });
    console.log(event)
    if (event.length > 0 && event[0] && event[0]['returnValues']) {
      return event[0]['returnValues'][0]
    }
    else {
      return false;
    }
  }
  catch (err) {
    console.log(err.message);
    return false;
  }
}


export const uploadFileIPFS = async (file = []) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const metadata = JSON.stringify({
      name: file.name,
    });
    formData.append("pinataMetadata", metadata);

    const options = JSON.stringify({
      cidVersion: 0,
    });
    formData.append("pinataOptions", options);

    const res = await fetch(
      "https://api.pinata.cloud/pinning/pinFileToIPFS",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
        },
        body: formData,
      }
    );

    if (!res.ok) {
      return { error: "Failed to upload file.Please try again." };
    }

    const resData = await res.json();
    if (!resData || !resData.IpfsHash) {
      return { error: "Failed to upload file.Please try again." };
    }

    return { error: 'OK', ipfs: resData.IpfsHash };
  }
  catch (err) {
    console.log(err.message);
    return { error: err.message };
  }
}


export const uploadMetadataToIPFS = async (metadata = []) => {
  try {
    if (metadata) {
      let token = localStorage.get('auth_token');
      let response = await api.post('nft//upload/metadata', {
        ...metadata,
        token
      });
      if (response && response.data && response.data.error === 'OK') {
        return { error: 'OK', ipfs: response.data.ipfsHash };
      }
      else {
        return { error: response.data.error };
      }
    }
    else {
      return { error: "no medata found" };
    }
  }
  catch (err) {
    console.log(err.message);
    return { error: err.message };
  }
}


export const getSaleCurrencyImg = (address = '', chainId) => {
  if (address && chainId) {
    let chain_info_currency = CHAIN_INFO[getCurrentChain(chainId)].currency_support;
    let getCurrency = chain_info_currency.filter((items) => items.address === address);
    if (getCurrency && getCurrency.length > 0) {
      return getCurrency[0].img;
    }
  }
  return '';
}